/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

import {
  RECEIVED_CONTRIBUTION_LIMIT,
  RECEIVED_CONTRIBUTION_PERIOD
} from './IRAContributionLimitActions';

export const iraContributionsLimitInitialState = {};

export const iraContributionsLimitReducer = (state, action) => {
  return action.type === RECEIVED_CONTRIBUTION_LIMIT ? action.payload : state;
};

export const iraContributionsPeriodInitialState = {
  isWithinPriorYearContributionPeriod: true
};

export const iraContributionsPeriodReducer = (
  state = iraContributionsPeriodInitialState,
  action
) => {
  return action.type === RECEIVED_CONTRIBUTION_PERIOD ? action.payload : state;
};
